// measureReducer.js
import { measureConstants as C } from './../actions/constants';

const initialState = {
    enabled: false,
    color: '#00e5ff',
    snapFloor: false, // ВКЛ => обе точки падают на пол
    items: [],
}

export default function measureReducer(state = initialState, action) {
    switch (action.type) {
        case C.SET_MEASURE_MODE:
            return { ...state, enabled: !!action.payload }

        case C.SET_MEASURE_COLOR:
            return { ...state, color: String(action.payload || '#00e5ff') }

        case C.SET_MEASURE_SNAP_FLOOR:
            return { ...state, snapFloor: !!action.payload }

        case C.ADD_MEASURE:
            return { ...state, items: [action.payload, ...state.items] }

        case C.REMOVE_MEASURE:
            return { ...state, items: state.items.filter((x) => x.id !== action.payload.id) }

        case C.TOGGLE_MEASURE:
            return {
                ...state,
                items: state.items.map((x) => x.id === action.payload.id ? { ...x, visible: !x.visible } : x),
            }

        case C.RENAME_MEASURE:
            return {
                ...state,
                items: state.items.map((x) => x.id === action.payload.id ? { ...x, name: action.payload.name } : x),
            }

        case C.SET_MEASURE_ITEM_COLOR:
            return {
                ...state,
                items: state.items.map((x) => x.id === action.payload.id ? { ...x, color: action.payload.color } : x),
            }

        case C.CLEAR_MEASURES:
            return { ...state, items: [] }

        default:
            return state
    }
}